import { defineStore } from 'pinia';
import { useRefreshStore } from '@/common/composables/refreshStore';
import { useListPackaging, type ListPackagingResponse } from '../api/listPackaging';
import { usePackagingStore } from 'shared/packages/stores/packagingStore';

export const useRefreshPackagingStore = defineStore('refresh-packaging', () => {
  const listPackaging = useListPackaging();
  const store = usePackagingStore();

  const { initialize, refresh } = useRefreshStore<ListPackagingResponse>({
    fetchFromServer() {
      return listPackaging.execute();
    },
    mergeToStore(response) {
      store.clear();
      store.merge(response.packaging);
    },
  });

  return {
    initialize,
    refresh,
  };
});
